(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["belluce-collection-homes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = 'true';
    root.addEventListener('click', function (event) {
      const button = event.target.closest('[data-bv-scroll]');
      if (!button) return;
      const track = root.querySelector('.bv-homes-track');
      if (!track) return;
      track.scrollBy({
        left: Number(button.dataset.bvScroll) * track.clientWidth * 0.8,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    });
  }
  document.querySelectorAll('[data-belluce-collection-homes]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-belluce-collection-homes]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["belluce-lamp-product"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const gallery=root.querySelector('.bp-gallery'),slides=Array.from(gallery.children),thumbs=document.createElement('div');thumbs.className='bp-thumbnails';gallery.after(thumbs);const mobile=matchMedia('(max-width:749px)'),motion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth';slides.forEach((slide,index)=>{const source=slide.querySelector('img'),video=slide.querySelector('video'),button=document.createElement('button'),image=document.createElement('img');button.type='button';button.className='bp-thumb';button.setAttribute('aria-label',(source?.alt||root.querySelector('h1').textContent)+' — '+(index+1));button.setAttribute('aria-controls',gallery.id);button.setAttribute('aria-current',String(index===0));image.src=video?.poster||source?.currentSrc||source?.src||'';image.alt='';image.loading='lazy';button.append(image);if(video||slide.querySelector('iframe')){const play=document.createElement('span');play.className='bp-thumb-play';play.textContent='▶';play.setAttribute('aria-hidden','true');button.append(play);}button.addEventListener('click',()=>gallery.scrollTo({left:slide.offsetLeft-slides[0].offsetLeft,behavior:motion()}));thumbs.append(button);});let galleryFrame;gallery.addEventListener('scroll',()=>{if(!mobile.matches)return;cancelAnimationFrame(galleryFrame);galleryFrame=requestAnimationFrame(()=>{const index=Math.round(gallery.scrollLeft/gallery.clientWidth);Array.from(thumbs.children).forEach((button,i)=>button.setAttribute('aria-current',String(i===index)));const active=thumbs.children[index];if(active&&(active.offsetLeft<thumbs.scrollLeft||active.offsetLeft+active.offsetWidth>thumbs.scrollLeft+thumbs.clientWidth))thumbs.scrollTo({left:active.offsetLeft-8,behavior:motion()});slides.forEach((slide,i)=>{if(i!==index)slide.querySelectorAll('video').forEach(video=>video.pause());});});},{passive:true});const slideTrack=root.querySelector('.bp-material-track'),dots=root.querySelector('[data-bp-dots]');if(slideTrack&&dots){Array.from(slideTrack.children).forEach((slide,i)=>{const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',slide.textContent.trim());button.setAttribute('aria-current',String(i===0));button.addEventListener('click',()=>slideTrack.scrollTo({left:i*slideTrack.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));dots.append(button);});slideTrack.addEventListener('scroll',()=>{const index=Math.round(slideTrack.scrollLeft/slideTrack.clientWidth);Array.from(dots.children).forEach((b,i)=>b.setAttribute('aria-current',String(i===index)));},{passive:true});}const variants=JSON.parse(root.querySelector('[data-bp-variants]').textContent),labels=JSON.parse(root.querySelector('[data-bp-labels]').textContent),form=root.querySelector('.bp-form'),add=root.querySelector('[data-bp-add]');function selected(){return variants.find(v=>String(v.id)===String(new FormData(form).get('id')))||variants[0];}function update(){const v=selected();root.querySelector('[data-bp-price]').textContent=v.fullPrice;const compare=root.querySelector('[data-bp-compare]'),save=root.querySelector('[data-bp-save]');compare.textContent=v.compare;compare.hidden=!v.saving;save.textContent=labels.save+' '+v.saving+'%';save.hidden=!v.saving;const option=root.querySelector('[data-bp-option]');if(option)option.textContent=v.title;add.disabled=!v.available;add.textContent=v.available?labels.add+' ('+v.price+')':labels.sold;const stock=root.querySelector('[data-bp-stock]');stock.replaceChildren();if(v.available)stock.append(document.createElement('span'));stock.append(document.createTextNode(v.available?labels.stock:labels.sold));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);}
form.addEventListener('change',e=>{if(e.target.name==='id')update();});
root.addEventListener('click',e=>{const qty=e.target.closest('[data-bp-quantity]');if(qty){const input=form.querySelector('[name=quantity]');input.value=Math.max(1,(parseInt(input.value,10)||1)+Number(qty.dataset.bpQuantity));}const more=e.target.closest('[data-bp-more]');if(more){const expanded=more.getAttribute('aria-expanded')!=='true';root.querySelector('.bp-gallery').classList.toggle('expanded',expanded);more.setAttribute('aria-expanded',String(expanded));more.textContent=expanded?more.dataset.less:more.dataset.more;}const arrow=e.target.closest('[data-bp-scroll]');if(arrow){const track=document.getElementById(arrow.getAttribute('aria-controls'));track.scrollBy({left:Number(arrow.dataset.bpScroll)*track.clientWidth*.8,behavior:'smooth'});}const tab=e.target.closest('[data-bp-tab]');if(tab){root.querySelectorAll('[data-bp-tab]').forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;document.getElementById(t.getAttribute('aria-controls')).hidden=!active;});}});
root.querySelector('.bp-tabs').addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const tabs=Array.from(root.querySelectorAll('[data-bp-tab]'));const next=e.key==='Home'?tabs[0]:e.key==='End'?tabs[tabs.length-1]:tabs[(tabs.indexOf(document.activeElement)+1)%tabs.length];next.click();next.focus();});
form.addEventListener('submit',async e=>{if(e.submitter&&e.submitter!==add)return;e.preventDefault();add.disabled=true;const status=root.querySelector('[data-bp-status]');status.textContent='';try{const drawer=document.querySelector('cart-drawer'),data=new FormData(form);if(drawer&&typeof drawer.getSectionsToRender==='function'){data.append('sections',drawer.getSectionsToRender().map(section=>section.id).join(','));data.append('sections_url',window.location.pathname);drawer.setActiveElement(add);}const response=await fetch(labels.addUrl,{method:'POST',body:data,headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});const result=await response.json();if(!response.ok)throw new Error(result.description||labels.error);status.textContent=labels.added;if(drawer&&result.sections){drawer.classList.remove('is-empty');drawer.renderContents(result);}else{const link=document.createElement('a');link.href=labels.cartUrl;link.textContent=labels.cart;status.append(link);}}catch(error){status.textContent=error.message||labels.error;}finally{add.disabled=!selected().available;}});
}
document.querySelectorAll('[data-belluce-product]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-belluce-product]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["belluce-reference-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-bv-scroll]');if(!button)return;const track=document.getElementById(button.getAttribute('aria-controls'));if(track)track.scrollBy({left:Number(button.dataset.bvScroll)*track.clientWidth*.8,behavior:'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
